import { forwardRef, useRef, useState } from 'react';
import { Reset } from '@sas/react-svg';
import { getKey, getKeyLabel } from '..';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { setRef } from '../../../util/ref-util';
import { Button, ButtonVariant } from '../../Button';
import { useIconA11yInfo } from '../../Icon/useIconA11yInfo';
import { BaseInput } from '../../Input/__internal__/BaseInput';
import { Flow } from '../../Layouts/Flow';
import bundle from '../NovaComponents-KeyboardShortcuts-gui-icu.properties';
import cn from './ShortcutsInput.css.json';
import './ShortcutsInput.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const ShortcutsInput = /*#__PURE__*/forwardRef((props, ref) => {
  const localize = useTextLocalizer();
  const getIconA11yInfo = useIconA11yInfo();
  const resetIconA11yInfo = getIconA11yInfo({
    icon: Reset
  });
  const clearButtonTooltip = localize('clear.button.tooltip.label');
  const [tempValue, setTempValue] = useState();
  const inputRef = useRef(null);
  const handleKeyDown = e => {
    // need the ability to focus out
    // F2 is used to quit edit mode in Table cell
    if (props.readOnly || e.key === 'Tab' || e.key === 'F2' && e.ctrlKey === false && e.shiftKey === false && e.altKey === false && e.metaKey === false) return;
    e.stopPropagation();
    e.preventDefault();
    setTempValue(getKey(e, props.platform));
  };
  const handleKeyUp = () => {
    if (tempValue === undefined) return;
    props.onChange?.(tempValue);
    setTempValue(undefined);
  };
  return /*#__PURE__*/_jsxs(Flow, {
    spacing: "xxs",
    className: props.className,
    style: props.style,
    children: [/*#__PURE__*/_jsx(BaseInput, {
      className: cn.input,
      value: getKeyLabel(tempValue ?? props.value, localize, props.platform),
      placeholder: localize('pressKeys.placeholder.label'),
      ref: element => {
        if (element) {
          element.addEventListener('keydown', handleKeyDown);
          element.addEventListener('keyup', handleKeyUp);
        } else {
          inputRef.current?.removeEventListener('keydown', handleKeyDown);
          inputRef.current?.removeEventListener('keyup', handleKeyUp);
        }
        inputRef.current = element;
        setRef(ref, element);
      },
      showClearButton: true,
      clearButtonTooltip: clearButtonTooltip,
      clearButtonAriaLabel: `${props.ariaLabel} ${clearButtonTooltip}`,
      onChange: () => props.onChange?.(''),
      onBlur: () => setTempValue(undefined),
      editable: !props.readOnly,
      status: props.showError ? 'alert' : undefined,
      message: localize('input.required.msg'),
      ariaLabel: props.ariaLabel
    }), props.readOnly ? null : /*#__PURE__*/_jsx(Button, {
      className: cn.button,
      icon: {
        icon: Reset
      },
      variant: ButtonVariant.Icon,
      disabled: props.defaultValue === '' || props.defaultValue === props.value,
      onPress: () => props.onChange?.(props.defaultValue),
      ariaLabel: `${props.ariaLabel} ${resetIconA11yInfo.ariaLabel}`
    })]
  });
});
//# sourceMappingURL=ShortcutsInput.js.map